import React from 'react';

import { AccountBalance, Piwik } from '@eika-kortbetjening/types';

import { CreditBar } from '../credit-bar';
import { formatAmount } from '../functions';

import './CreditInformation.scss';

interface CreditInformationProps {
    balance: AccountBalance;
    title?: string;
    piwik: Piwik | undefined;
}

const CreditInformation = ({ balance, piwik, title = 'Du har brukt' }: CreditInformationProps) => {
    const formattedAvailableCredit = formatAmount(balance.balance, 2, true);
    const formattedCreditLimit = formatAmount(balance.limit, 0, true);

    return (
        <div className="credit-information">
            <h2 className="balance-header">{title}</h2>
            <div
                aria-describedby="spent-credit"
                aria-label={`Du har brukt ${formatAmount(balance.saldo, 0, true, true)}`}
                className="spent-credit"
                data-track-id={piwik?.transactions?.spentCredit?.dataTrackId}
                data-track-linkname={piwik?.transactions?.spentCredit?.dataTrackLinkname}
                id={piwik?.transactions?.spentCredit?.dataTrackId}
            >
                <p title="Du har brukt">{formatAmount(balance.saldo, 2, true, true)}</p>
            </div>
            <div className="credit-bar-container">
                <CreditBar balance={balance.balance} creditLimit={balance.limit} piwik={piwik} />
            </div>
            <div id="available-credit" className="available-credit">
                <span className="bold">{formattedAvailableCredit}</span>
                <span> tilgjengelig av </span>
                <span className="bold">{formattedCreditLimit}</span>
            </div>
        </div>
    );
};

export default CreditInformation;
